module.exports = __webpack_public_path__ + "img/452.163a72a7.jpg";